import { IProductReview } from "../../repository/IProductReview";

export const addProductReview = (payload: IProductReview) => ({
  type: "@saga/ADD_PRODUCT_REVIEW",
  payload,
});
